import { LanguageDocument } from "../../models/workflow.model";
import DocumentDownloadButton from "./DocumentDownloadButton";
import DocumentDownloadMultiple from "./DocumentDownloadMultiple";

interface Props {
  documentId?: number;
  type?: "icon" | "button" | undefined;
  text?: string;
  documents?: LanguageDocument[];
}

const DocumentDownload: React.FC<Props> = ({
  documentId,
  type,
  text,
  documents,
}) => {
  return documents != null && documents.length > 0 ? (
    documents.length > 1 ? (
      <DocumentDownloadMultiple documents={documents} />
    ) : (
      <DocumentDownloadButton
        documentId={documents[0].documentId}
        text={documents[0].langCode}
        type={type}
      />
    )
  ) : documentId != null ? (
    <DocumentDownloadButton documentId={documentId} text={text} type={type} />
  ) : (
    <></>
  );
};

export default DocumentDownload;
